"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketConnection = void 0;
var LoggerFactory_1 = require("../factory/LoggerFactory");
var HttpClient_1 = require("../service/HttpClient");
var currentDate_1 = require("../helper/currentDate");
var LocalStorage_1 = require("./LocalStorage");
var enum_1 = require("../enum");
var SocketConnection = (function () {
    function SocketConnection(websocketUrl, groupId, clientName) {
        var _this = this;
        this.pingMessageId = 0;
        this.websocketUrl = '';
        this.group = '';
        this.clientName = '';
        this.clientId = '';
        this.lastSentPosition = 0;
        this.logger = LoggerFactory_1.LoggerFactory.createLogger();
        HttpClient_1.default.getServerTime().then(function (result) {
            _this.serverTimeDelay = result;
        });
        this.websocketUrl = websocketUrl;
        this.group = groupId;
        this.clientName = clientName;
    }
    SocketConnection.prototype.closeWebsocket = function () {
        if (this.websocketClient) {
            this.websocketClient.close();
        }
        this.websocketClient = null;
    };
    SocketConnection.prototype.connectToSyncServer = function (client, subscriptionResult, syncEvent) {
        var _this = this;
        var token = LocalStorage_1.getToken();
        if (token) {
            if (!this.websocketClient) {
                this.websocketClient = new WebSocket(this.websocketUrl + '?groupId=' + this.group + '&name=' + this.clientName + '&token=' + token);
            }
            if (this.websocketClient.readyState === this.websocketClient.OPEN) {
                this.logger.log('Socket connection was opened');
            }
            this.websocketClient.onclose = function (closeEvent) {
                _this.logger.log('Socket connection was closed');
            };
            this.websocketClient.onmessage = function (e) {
                var data = JSON.parse(e.data);
                if (data.type === enum_1.IncomeMessage.frequency) {
                    _this.clientId = data.data.id;
                    subscriptionResult(data);
                }
                else {
                    var ownMessage = false;
                    if (data.type === enum_1.IncomeMessage.chat_message) {
                        if (_this.clientId === data.data.id) {
                            ownMessage = true;
                        }
                    }
                    syncEvent(data, ownMessage);
                }
            };
        }
        else {
            throw new Error('[WS]: Access token is invalid ! Please check credential token !');
        }
    };
    SocketConnection.prototype.sendClientPosition = function (client, streamOffset) {
        if (this.lastSentPosition === client.getCurrentPosition()) {
            console.log('[WS]: Previous position is equal current position ');
            return;
        }
        this.lastSentPosition = client.getCurrentPosition();
        var playerPosition = streamOffset + client.getCurrentPosition() * 1000;
        if (this.websocketClient)
            this.websocketClient.send(JSON.stringify({
                data: {
                    id: client.getPlayerId(),
                    position: Math.floor(playerPosition),
                    timestamp: currentDate_1.default(this.serverTimeDelay)
                },
                type: enum_1.OutcomeMessage.position
            }));
    };
    SocketConnection.prototype.sendClientPositionDT = function (client, streamOffset, rememberedPosition) {
        if (this.lastSentPosition === client.getCurrentPosition()) {
            console.log('[WS]: Previous position is equal current position ');
            return;
        }
        this.lastSentPosition = client.getCurrentPosition();
        var playerPosition = streamOffset + (client.getCurrentPosition() - rememberedPosition) * 1000;
        if (this.websocketClient)
            this.websocketClient.send(JSON.stringify({
                data: {
                    id: client.getPlayerId(),
                    position: Math.floor(playerPosition),
                    rate: 1,
                    timestamp: currentDate_1.default(this.serverTimeDelay)
                },
                type: enum_1.OutcomeMessage.position
            }));
    };
    SocketConnection.prototype.groupPlay = function () {
        if (this.websocketClient)
            this.websocketClient.send(JSON.stringify({
                data: {
                    groupId: this.group
                },
                type: enum_1.OutcomeMessage.sync_group_play
            }));
    };
    SocketConnection.prototype.changeVolume = function (volume) {
        if (this.websocketClient)
            this.websocketClient.send(JSON.stringify({
                data: {
                    groupId: this.group,
                    volume: volume
                },
                type: enum_1.OutcomeMessage.change_group_volume
            }));
    };
    SocketConnection.prototype.groupPause = function () {
        if (this.websocketClient)
            this.websocketClient.send(JSON.stringify({
                data: {
                    groupId: this.group
                },
                type: enum_1.OutcomeMessage.sync_group_pause
            }));
    };
    SocketConnection.prototype.muteGroup = function () {
        if (this.websocketClient)
            this.websocketClient.send(JSON.stringify({
                data: {
                    groupId: this.group
                },
                type: enum_1.OutcomeMessage.mute_group
            }));
    };
    SocketConnection.prototype.getClientList = function () {
        if (this.websocketClient)
            this.websocketClient.send(JSON.stringify({
                data: {
                    groupId: this.group,
                    id: this.clientId
                },
                type: enum_1.OutcomeMessage.get_client_list
            }));
    };
    SocketConnection.prototype.sendMessageToGroup = function (message) {
        if (this.websocketClient)
            this.websocketClient.send(JSON.stringify({
                data: {
                    groupId: this.group,
                    id: this.clientId,
                    message: message,
                    name: this.clientName
                },
                type: enum_1.OutcomeMessage.chat_message
            }));
    };
    SocketConnection.prototype.sendEventToGroup = function (payload) {
        if (this.websocketClient)
            this.websocketClient.send(JSON.stringify({
                data: payload,
                type: enum_1.OutcomeMessage.event_to_group
            }));
    };
    return SocketConnection;
}());
exports.SocketConnection = SocketConnection;
//# sourceMappingURL=SocketConnection.js.map